import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import { ComplaintByStatus } from './components'
import { DashboardCounterCard } from 'components'

import constants from 'constants/index'

const DashboardComplaint = ({ complaintStats }) => {
  const { complaint: complaintIds } = constants.myLgpd.GRAPH_IDS

  const complaints = complaintStats?.complaints || []

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Canal de Denúncias
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <DashboardCounterCard
            label="Quantidade Total de Denúncias"
            value={complaints?.length}
            sizes={{ xs: 12, md: 6 }}
          />
          <Grid item xs={12} md={6}>
            <ComplaintByStatus
              complaints={complaints}
              id={complaintIds.complaintByStatus}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardComplaint.propTypes = {
  complaintStats: PropTypes.object.isRequired,
}

export default DashboardComplaint
